export enum PlatformBrandName {
    IDENTITY_MATRIX = 1,
    QUALIGENCE = 2,
}

export const PlatformBrandNameMap: { [key: number]: string } = {
    [PlatformBrandName.IDENTITY_MATRIX]: "Identity Matrix",
    [PlatformBrandName.QUALIGENCE]: "Talent Matrix",
};